import React from "react";
import { MaterialReactTable } from "material-react-table";
import { sharedTableProps } from "../shared/tableProps";
import AddToolbarLink from "../shared/AddToolbarLink";

const FileTransferViewTable = ({ data, mainColumns }) => (
  <MaterialReactTable
    {...sharedTableProps}
    columns={mainColumns}
    data={data}
    initialState={{
      density: "compact",
      columnVisibility: { TRANSFER_ID: true },
    }}
    renderTopToolbarCustomActions={() => (
      <AddToolbarLink to="/AddFileTransfer" label="Add Transfer" />
    )}
  />
);

export default FileTransferViewTable;
